import { Stack, Typography } from '@mui/material'

export interface DeviceDetail {
  label: string
  value?: string | null
}

/**
 * What the row about to be deleted actually is.
 *
 * The delete confirmations name the device, but a name alone ("fs1-1") is easy
 * to mistake for its neighbour, so the decoder it sits on and the rest of the
 * row's identifying fields are shown with it. Empty fields are dropped rather
 * than drawn blank.
 */
const DeleteDeviceDetails = ({ details }: { details: DeviceDetail[] }) => {
  const rows = details.filter((detail) => Boolean(detail.value))
  if (!rows.length) return null

  return (
    <Stack
      spacing={0.5}
      sx={{
        maxWidth: '314px',
        mt: '4px',
        p: '10px 12px',
        borderRadius: '8px',
        border: '1px solid',
        borderColor: 'border.main',
        backgroundColor: 'background.paper',
      }}
    >
      {rows.map((detail) => (
        <Stack
          key={detail.label}
          direction="row"
          sx={{ gap: '12px', justifyContent: 'space-between' }}
        >
          <Typography sx={{ fontSize: '12px', color: 'grey.600' }}>
            {detail.label}
          </Typography>
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: 600,
              color: 'text.main',
              textAlign: 'right',
              overflowWrap: 'anywhere',
            }}
          >
            {detail.value}
          </Typography>
        </Stack>
      ))}
    </Stack>
  )
}

export default DeleteDeviceDetails
